export default __webpack_public_path__ + "static/media/loading.71e5febe.gif";